<template>
  <div class="modal fade" id="passwordUpdateHeaderModal" tabindex="-1" aria-labelledby="passwordUpdateModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="passwordUpdateModalLabel">パスワード更新</h5>
          <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <form id="passwordUpdateForm" @submit.prevent="submitNewPassword">
            <div class="mb-3">
              <label for="password" class="form-label">新しいパスワード:</label>
              <input 
                type="password" 
                id="password" 
                name="password" 
                class="form-control" 
                v-model="password" 
                required 
              />
            </div>
            <div class="mb-3">
              <label for="passwordConfirmation" class="form-label">パスワード確認:</label>
              <input 
                type="password" 
                id="passwordConfirmation" 
                name="passwordConfirmation" 
                class="form-control" 
                v-model="passwordConfirmation" 
                required 
              />
            </div>
            <div v-if="errorMessages.password || errorMessages.password_confirmation" class="alert alert-danger">
              <p v-if="errorMessages.password">{{ errorMessages.password }}</p>
              <p v-if="errorMessages.password_confirmation">{{ errorMessages.password_confirmation }}</p>
            </div>
            <div class="btn-area">
              <button type="button" class="btn btn-secondary mx-1" @click="close">キャンセル</button>
              <button type="submit" class="btn btn-success mx-1">更新</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue';
import { useStore } from 'vuex';
import { passwordUpdate } from '@/api/axios';
import { Modal } from 'bootstrap';

export default {
  props: ['userId'],
  setup(props, { emit }) {
    const store = useStore();
    const password = ref('');
    const passwordConfirmation = ref('');
    const errorMessages = ref({});

    const close = () => {
      const modalElement = document.getElementById('passwordUpdateHeaderModal');
      if (modalElement) {
        const modal = Modal.getOrCreateInstance(modalElement);
        modal.hide();
      }
      emit('onClose'); // 親コンポーネントに通知
      password.value = '';
      passwordConfirmation.value = '';
      errorMessages.value = {};
    };

    const submitNewPassword = async () => {
      await nextTick(); // フォームが完全にレンダリングされたことを保証
      const form = document.querySelector('#passwordUpdateForm');
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (password.value !== passwordConfirmation.value) {
        alert('パスワードが一致しません。');
        return;
      }

      try {
        await passwordUpdate({
          user_id: props.userId,
          password: password.value,
          password_confirmation: passwordConfirmation.value,
        });
        store.dispatch('setFlashMessage', { message: 'パスワードがリセットされました', type: 'success' });
        close();
      } catch (error) {
        if (error.response && error.response.data) {
          errorMessages.value = error.response.data.errors || {};
        }
        store.dispatch('setFlashMessage', { message: 'パスワードリセットに失敗しました', type: 'danger' });
        console.error('パスワードリセットに失敗しました:', error);
      }
    };

    return {
      password,
      passwordConfirmation,
      close,
      submitNewPassword,
      errorMessages,
    };
  },
};
</script>

<style scoped>
.label {
  display: block;
  margin-bottom: 5px;
}

.btn-area {
  margin-top: 24px;
  text-align: right;
}

.modal-backdrop {
  z-index: -1 !important;
}

.alert {
  margin-top: 10px;
}
</style>
